// Ein Prüfpunkt im Raum (Handoff §4.2): Segment i. O. (grün) | Mangel (rot). Erneutes Tippen setzt wie
// bisher denselben Wert (kein Zurück auf „offen“). Bei Mangel: Zeile rot hinterlegt, Notiz und Fotos.
import React from 'react';
import { Check, Warning } from '@phosphor-icons/react';
import type { Pruefpunkt } from '../../../lib/uebergabe/typen';
import FotoVorschau from './FotoVorschau';
import { FotoKachel, FotoReihe, istTouch } from './assistent/Rundgangteile';

interface PruefpunktZeileProps {
  pp: Pruefpunkt;
  fotos: Record<string, Blob>;
  aendere: (patch: Partial<Pruefpunkt>) => void;
  fotosHinzufuegen: (dateien: FileList) => void;
}

const PruefpunktZeile: React.FC<PruefpunktZeileProps> = ({ pp, fotos, aendere, fotosHinzufuegen }) => {
  const hoehe = istTouch() ? 44 : 34;
  const knopf = (an: boolean, farbe: string) => ({
    height: hoehe, padding: '0 12px', gap: 5, border: 'none', borderRadius: 11, cursor: 'pointer', fontFamily: 'inherit', fontSize: 12.5,
    fontWeight: 800, display: 'inline-flex', alignItems: 'center',
    background: an ? farbe : 'transparent', color: an ? '#fff' : 'var(--ink2)', boxShadow: an ? `0 6px 14px -8px ${farbe}` : 'none',
  } as const);
  const mangel = pp.status === 'mangel';
  return (
    <div className="ios-zeile flex flex-col" style={{ padding: '8px 10px 8px 14px', gap: 10, background: mangel ? 'var(--bad-soft)' : 'transparent' }}>
      <div className="flex items-center" style={{ gap: 10, minHeight: hoehe }}>
        <span className="min-w-0 flex-1" style={{ fontSize: 14.5, fontWeight: 700, color: mangel ? 'var(--bad)' : 'var(--ink)' }}>{pp.name}</span>
        <span role="radiogroup" aria-label={`Zustand ${pp.name}`} className="inline-flex shrink-0" style={{ padding: 3, gap: 2, borderRadius: 13, background: 'var(--fill2)' }}>
          <button type="button" role="radio" aria-checked={pp.status === 'io'} data-tip="In Ordnung" onClick={() => aendere({ status: 'io' })} style={knopf(pp.status === 'io', '#34c759')}>
            <Check size={13} weight="bold" /> i. O.
          </button>
          <button type="button" role="radio" aria-checked={mangel} data-tip="Mangel – Beanstandung mit Notiz und Foto festhalten" onClick={() => aendere({ status: 'mangel' })}
            style={knopf(mangel, '#ff3b30')}>
            <Warning size={13} weight="bold" /> Mangel
          </button>
        </span>
      </div>
      {mangel && (
        <div className="flex flex-col" style={{ gap: 8 }}>
          <textarea value={pp.notiz} onChange={e => aendere({ notiz: e.target.value })} placeholder="Was ist zu beanstanden?" rows={2} aria-label={`Mangel ${pp.name}`}
            style={{ width: '100%', resize: 'vertical', border: 'none', outline: 'none', borderRadius: 12, padding: '10px 12px', background: 'var(--bg)',
              boxShadow: 'inset 0 0 0 1px var(--line)', fontFamily: 'inherit', fontSize: 14, lineHeight: 1.45, color: 'var(--ink)' }} />
          <FotoReihe>
            {pp.fotos.map(pfad => (fotos[pfad] ? <FotoVorschau key={pfad} blob={fotos[pfad]} groesse={56} /> : null))}
            <FotoKachel groesse={56} tip="Foto zum Mangel" onDateien={fotosHinzufuegen} />
          </FotoReihe>
        </div>
      )}
    </div>
  );
};

export default PruefpunktZeile;
